// extracted by mini-css-extract-plugin
var _1 = "ra-editorial";
var _2 = "ra-editorial-details";
var _3 = "ra-editorial-details-title";
var _4 = "ra-editorial-item";
export { _1 as "editorialCls", _2 as "editorialDetailsCls", _3 as "editorialDetailsTitleCls", _4 as "editorialItemCls" }
